

var _squid = require('squid');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SmartAuthFactory', function () {

    var isAuthRequired = function isAuthRequired(fs) {
        return fs.constraint;
    };

    var getConstraintAmount = function getConstraintAmount(fs) {
        var constraint = fs.constraint;

        return (0, _squid.formatCurrency)(constraint.amount.value, constraint.amount.currency, false);
    };

    var disallowedManageLinkExp = function disallowedManageLinkExp() {
        return (0, _squid.$elmo)('xo_hermes_display_disallowed_fi', { 'ctx.country': _squid.$locale.country }, 'Trmt_xo_hermes_display_disallowed_fi_1').then(function (result) {
            return result && result.treatment_name;
        });
    };

    // Experiment that controls if user can or cannot use PayPal Balance as an FI
    // We use it to display the correct consent texts
    var noBalanceExp = function noBalanceExp() {
        return (0, _squid.$elmo)('xo_hermes_no_balance_agreement', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_no_balance_agreement_1').then(function (result) {
            return { enabled: Boolean(result && result.treatment_name) };
        });
    };

    // Experiment that controls if user has the disallowed balance use case
    // where the same consent content as no balance will be displayed
    var disallowedBalanceExp = function disallowedBalanceExp() {
        return (0, _squid.$elmo)('xo_hermesnodeweb_disallowed_balance', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_FEATURE_HERMES_DISALLOWED_BALANCE').then(function (result) {
            return { enabled: Boolean(result && result.treatment_name) };
        });
    };

    var subscriptionNoBalanceLegalTextExp = function subscriptionNoBalanceLegalTextExp() {
        return (0, _squid.$elmo)('xo_hermes_subs_no_balance_legal_text', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_subs_no_balance_legal_text').then(function (result) {
            return { enabled: Boolean(result && result.treatment_name) };
        });
    };

    return {
        isAuthRequired: isAuthRequired,
        getConstraintAmount: getConstraintAmount,
        disallowedManageLinkExp: disallowedManageLinkExp,
        disallowedBalanceExp: disallowedBalanceExp,
        noBalanceExp: noBalanceExp,
        subscriptionNoBalanceLegalTextExp: subscriptionNoBalanceLegalTextExp
    };
});

_squid.formatCurrency;

_squid.$elmo;

_squid.$locale;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/review-paywith/factory.js
// module id = ../node_modules/xo-member-components/src/review-paywith/factory.js
// module chunks = 0